import { Outlet, useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import { Box } from '@mui/material';

const Layout = () => {
    const location = useLocation();
    const currentLocation = location.pathname.split('/');
    const inputsPage = currentLocation.includes('inputs');

    return (
        <>
            <NavBar />
            <Box
                display='flex'
                flexDirection='column'
                sx={{
                    // viewport height minus <NavBar/> - fallback provided for dvh
                    height: ['calc(100vh - 56px)', 'calc(100dvh - 56px)']
                }}
            >
                {/* Scrollable - this is the <main/> scrollable content container of the page */}
                <Box
                    component='main'
                    // available height minus <footer/> if on Inputs page
                    height={inputsPage ? 'calc(100% - 74px)' : '100%'}
                    overflow='auto'
                    display='flex'
                    flexDirection='column'
                    alignItems='center'
                    justifyContent='flex-start'
                    padding={2}
                >
                    <Outlet />
                </Box>
            </Box>
        </>
    );
};

export default Layout;
